/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_3_DescInputs */

const en_mk_parts_3_desc = /** @type {(inputs: Mk_Parts_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every division gets an agent with its own name, instructions and permissions. It appears in the assignee list next to people, moves the status and reports what it did.`)
};

const id_mk_parts_3_desc = /** @type {(inputs: Mk_Parts_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap divisi dapat satu agen dengan nama, instruksi, dan izin sendiri. Ia muncul di daftar assignee bersama manusia, mengubah status, dan melaporkan hasilnya.`)
};

/**
* | output |
* | --- |
* | "Every division gets an agent with its own name, instructions and permissions. It appears in the assignee list next to people, moves the status and reports wh..." |
*
* @param {Mk_Parts_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_3_desc = /** @type {((inputs?: Mk_Parts_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_3_desc(inputs)
	return en_mk_parts_3_desc(inputs)
});